module.exports = __webpack_public_path__ + "static/media/logo.2800cf47.svg";